import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { ImThemeProviderZenith } from '@im/im-theme';
import { MuiProviders } from '@im/ui-lib/theme/MuiProviders';

export const Error404 = () => {
  return (
    <ImThemeProviderZenith>
      <MuiProviders>
        <Stack
          alignItems="center"
          height="100vh"
          id="error-view"
          justifyContent="center"
          pb={24}
          pt={24}
        >
          <Stack maxWidth={1280} pl={8} pr={8} width="100%">
            <Typography color="primary.700" mb={3} variant="text-md-semibold">
              404 error
            </Typography>
            <Typography color="gray.900" mb={6} variant="display-xl-semibold">
              We can't find that page
            </Typography>
            <Typography color="gray.600" variant="text-xl-regular">
              Sorry, the storefront you are looking for doesn't exist or has
              been moved.
            </Typography>
          </Stack>
        </Stack>
      </MuiProviders>
    </ImThemeProviderZenith>
  );
};
